import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.slice";
import _defineProperty from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import 'swiper/css/swiper.css';
import Bus from '@/util/eventBus';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper/dist/vue-awesome-swiper.esm';
import IconArrow from '@vip-activity/ui/components/icon/IconArrow.vue';
import { format } from '@tencent/vft-common/date';
import Storage from '@tencent/vft-common/Storage';
import config from '@/config';
import FriendPop from '../FriendPop/FriendPop.vue';
import HuoMask from '../HuoMask/HuoMask.vue';
import Pop from '../Pop/Pop.vue';
export default {
  name: '',
  components: {
    Swiper: Swiper,
    SwiperSlide: SwiperSlide,
    IconArrow: IconArrow,
    FriendPop: FriendPop,
    HuoMask: HuoMask,
    Pop: Pop
  },
  data: function data() {
    // eslint-disable-next-line no-underscore-dangle
    var _this = this;

    return {
      curOrderid: '',
      popVisible: false,
      buyListInit: false,
      popType: 1,
      swiperOption: {
        slidesPerView: 'auto',
        slidesOffsetBefore: 16,
        slidesOffsetAfter: 16,
        spaceBetween: 16,
        speed: 600,
        on: {
          slideChange: function slideChange() {
            // 因为slidesPerview不是1的缘故，最后的一个index不会触发，所以预先拉取下一个slide对应的领取信息
            console.log('change', this.activeIndex);
            var order = _this.buyList[this.activeIndex + 1];
            var orderid = order && order.sOrderId;

            if (orderid) {
              if (!_this.receiveInfo[orderid]) {
                _this.getOrderReceiveList(orderid);
              }
            }
          }
        }
      }
    };
  },
  computed: {
    originBuyList: function originBuyList() {
      return this.$store.state.buyList || [];
    },
    buyList: function buyList() {
      return this.originBuyList.filter(function (order) {
        return !(order.bBuyForYourself && order.iTicketNum === 1);
      });
    },
    receiveInfo: function receiveInfo() {
      return this.$store.state.receiveInfo;
    },
    popList: function popList() {
      var _this2 = this;

      var receiveList = this.receiveInfo[this.curOrderid] || [];

      if (this.popType === 2) {
        receiveList = receiveList.filter(function (item) {
          return "".concat(item.vuid) !== config.vuid;
        });
      }

      return receiveList.map(function (item) {
        var text = _this2.formatTime(item.time * 1000, 'Y-mm-dd H:i');

        return {
          nick: item.nick,
          headurl: item.head,
          rightText: text,
          level: item.vip_level || 0
        };
      });
    },
    popTitle: function popTitle() {
      if (this.popType === 2) {
        return 'https://vfiles.gtimg.cn/vupload/20200615/eddad11592236447494.png';
      }

      return 'https://vfiles.gtimg.cn/vupload/202006/93a7251591081978060.png';
    }
  },
  watch: {
    buyList: function buyList() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var lastOrder, secondOrder, orderid, _orderid, receiveInfo, curList, oldList;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                lastOrder = _this3.buyList[0];
                secondOrder = _this3.buyList[1]; // 因为slidesPerview不是1的缘故，最后的一个index不会触发，所以预先拉取下一个slide对应的领取信息

                if (secondOrder) {
                  orderid = secondOrder.sOrderId;

                  _this3.getOrderReceiveList(orderid);
                }

                if (!lastOrder) {
                  _context.next = 28;
                  break;
                }

                _orderid = lastOrder.sOrderId;
                _context.next = 7;
                return _this3.getOrderReceiveList(_orderid);

              case 7:
                if (!_this3.buyListInit) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt("return");

              case 9:
                receiveInfo = {};
                _context.prev = 10;
                receiveInfo = Storage.getJSON('huoshao-receive');
                Storage.setJSON('huoshao-receive', _objectSpread(_objectSpread({}, receiveInfo), {}, _defineProperty({}, config.vuid, _objectSpread(_objectSpread({}, receiveInfo[config.vuid]), _this3.receiveInfo))));
                curList = _this3.receiveInfo[_orderid];

                if (curList.length) {
                  _context.next = 16;
                  break;
                }

                return _context.abrupt("return");

              case 16:
                if (!_this3.onlySelf(lastOrder)) {
                  _context.next = 18;
                  break;
                }

                return _context.abrupt("return");

              case 18:
                if (!(!receiveInfo || !receiveInfo[config.vuid])) {
                  _context.next = 21;
                  break;
                }

                _this3.showPopList2(_orderid);

                return _context.abrupt("return");

              case 21:
                oldList = receiveInfo[config.vuid][_orderid];

                if (!Array.isArray(oldList) || curList.length !== oldList.length) {
                  _this3.showPopList2(_orderid);
                }

                _context.next = 28;
                break;

              case 25:
                _context.prev = 25;
                _context.t0 = _context["catch"](10);
                console.error(_context.t0);

              case 28:
                _this3.buyListInit = true;

              case 29:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[10, 25]]);
      }))();
    }
  },
  methods: {
    getRemainNum: function getRemainNum(order) {
      return order.iTicketNum - order.iHasGotNum;
    },
    getFriendList: function getFriendList(list) {
      if (Array.isArray(list)) {
        return list.slice(0, 3);
      }

      return [];
    },
    formatTime: function formatTime(time) {
      var pattern = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Y-mm-dd';

      if (typeof time === 'number') {
        return format(new Date(time), pattern);
      }

      return time;
    },
    launchShare: function launchShare(order) {
      Bus.$emit('launchShare', {
        type: 1,
        orderid: order.sOrderId,
        num: this.getRemainNum(order),
        allNum: order.iTicketNum,
        sendDesc: '送出'
      });
    },
    getOrderReceiveList: function getOrderReceiveList(orderid) {
      return this.$store.dispatch('getOrderReceiveList', orderid);
    },
    showPopList: function showPopList(orderid) {
      var popType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      this.curOrderid = orderid;
      this.popType = popType;
      this.popVisible = true; // 1查看领取的好友|2显示新领取的好友弹窗

      if (popType === 1) {
        this.getOrderReceiveList(orderid);
      }
    },
    showPopList2: function showPopList2(orderid) {
      console.log('弹窗提示用户有新领取');

      if (this.initPop) {
        return;
      }

      this.initPop = true;
      this.showPopList(orderid, 2);
    },
    onlySelf: function onlySelf(order, receiveList) {
      // eslint-disable-next-line no-param-reassign
      receiveList = receiveList || this.receiveInfo[order.sOrderId];

      if (order.iHasGotNum === 1) {
        if (Array.isArray(receiveList)) {
          if ("".concat(receiveList[0].vuid) === config.vuid) {
            return true;
          }
        }
      }

      return false;
    },
    isLiveOrder: function isLiveOrder() {
      var order = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return new Date(order.lCreatTime * 1000) < new Date(window.setting.直播结束时间);
    }
  }
};